export default __webpack_public_path__ + "static/media/project-srt.cc0e76eb.svg";